<template>
    <div class="TextTab p-3 py-5">
        <div v-for="(item, index) of AppsList" v-bind:key="index">
            <div class="mt-6 mb-3">
                <label class="block text-xs font-bold text-gray-700 uppercase tracking-widest mb-2 text-left">
                    {{ item.Sectionlabel }}
                </label>
            </div>
            <div class="row">
                <div v-for="(childItem, Indexs) of item.children" v-bind:key="Indexs" class="col-6 mb-3"
                    @click="addWidget(childItem.name)">
                    <div class="cardWrapper">
                        <div
                            class="bg-light text-center p-3 mb-2 rounded position-relative d-flex align-items-center justify-content-center h-16">
                            <img :src="childItem.icon" class="position-absolute h-100 w-100 object-contain px-2 py-3" />
                        </div> 
                        <div class="text-center mt-1 text-xs">
                            {{ childItem.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';


const newsType = {
    "Aljazeera": { url: "https://www.aljazeera.com/xml/rss/all.xml", id: "Aljazeera" },
    "BBC": { url: "http://feeds.bbci.co.uk/news/rss.xml", id: "BBC" },
    "Clarin": { url: "https://www.clarin.com/rss/lo-ultimo/", id: "Clarin" },
    "CNN": { url: "http://rss.cnn.com/rss/cnn_latest.rss", id: "CNN" },
    "ESPN": { url: "http://www.espn.com/espn/rss/news", id: "ESPN" },
    "Fox": { url: "https://moxie.foxnews.com/google-publisher/latest.xml", id: "Fox" },
    "Google": { url: "https://news.google.com/news/rss", id: "Google" },
    "NTV": { url: "https://www.n-tv.de/rss", id: "NTV" },
    "WWD": { url: "https://wwd.com/custom-feed/recent-stories/", id: "WWD" },
    "Yahoo": { url: "https://news.yahoo.com/rss/", id: "Yahoo" },
}

export default {
    name: "AppsTab",
    data() {
        return {
            AppsList: [
                {
                    Sectionlabel: "Featured",
                    children: [
                        // {
                        //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/looker/thumbnail.png",
                        //     name: "Looker"
                        // },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/worldclock/thumbnail.png",
                            name: "World Clock"
                        },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/weather/thumbnail.png",
                            name: "World Weather"
                        },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/youtube/thumbnail.png",
                            name: "Youtube App"
                        },
                    ]
                },
                {
                    Sectionlabel: "Business",
                    children: [
                        // {
                        //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/menu/thumbnail.png",
                        //     name: "Digital Menu"
                        // },
                        // {
                        //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/dropbox/thumbnail.png",
                        //     name: "Dropbox Showcase"
                        // },
                        // {
                        //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/google-docs/thumbnail.png",
                        //     name: "Google docs"
                        // },
                        // {
                        //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/google-drive/thumbnail.png",
                        //     name: "Google Drive"
                        // },
                        // {
                        //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/google-sheets/thumbnail.png",
                        //     name: "Google Sheets"
                        // },
                        // {
                        //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/google-slides/thumbnail.png",
                        //     name: "Google Slides"
                        // },
                        // {
                        //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/postermywall/thumbnail.png",
                        //     name: "PosterMyWall"
                        // },
                        // {
                        //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/powerbi/thumbnail.png",
                        //     name: "PowerBI Dashboards"
                        // },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/qr/thumbnail.png",
                            name: "QR Code"
                        },

                    ]
                },
                {
                    Sectionlabel: "Misc",
                    children: [
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/calendar/thumbnail.png",
                            name: "Calendar"
                        },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/countdown/thumbnail.png",
                            name: "Countdown"
                        },
                        // {
                        //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/google-calendar-2.0/thumbnail.png",
                        //     name: "Google Calender"
                        // },
                        // {
                        //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/timezone.io/thumbnail.png",
                        //     name: "Timezone.io"
                        // },
                        // {
                        //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/transit/thumbnail.png",
                        //     name: "Transit"
                        // },


                    ]
                },
                {
                    Sectionlabel: "News",
                    children: [
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/aljazeera/thumbnail.png",
                            name: "Aljazeera News"
                        },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/bbc/thumbnail.png",
                            name: "BBC News"
                        },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/clarin/thumbnail.png",
                            name: "Clarin News"
                        },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/cnn/thumbnail.png",
                            name: "CNN News"
                        },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/espn/thumbnail.png",
                            name: "ESPN"
                        },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/googlenews/thumbnail.png",
                            name: "Google News"
                        },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/foxnews/thumbnail.png",
                            name: "Fox News"
                        },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/ntv/thumbnail.png",
                            name: "NTV News"
                        },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/wwdnews/thumbnail.png",
                            name: "WWD News"
                        },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/yahoonews/thumbnail.png",
                            name: "Yahoo News"
                        },
                    ]
                },
                // {
                //     Sectionlabel: "Social",
                //     children: [
                //         // {
                //         //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/facebook-post/thumbnail.png",
                //         //     name: "Facebook Post"
                //         // },
                //         // {
                //         //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/wall/thumbnail.png",
                //         //     name: "Fugo Social Wall"
                //         // },
                //         // {
                //         //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/twitter/thumbnail.png",
                //         //     name: "Twitter Feed"
                //         // },
                //         // {
                //         //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/walls.io/thumbnail.png",
                //         //     name: "Walls.io"
                //         // },
                //     ]
                // },
                {
                    Sectionlabel: "Utilities",
                    children: [
                        // {
                        //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/rss/thumbnail.png",
                        //     name: "RSS"
                        // },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/web/thumbnail.png",
                            name: "Web Page"
                        },
                    ]
                },
                {
                    Sectionlabel: "video",
                    children: [
                        // {
                        //     icon: "https://fugo-apps-prod.s3.amazonaws.com/app/video-stream/thumbnail.png",
                        //     name: "Video Stream"
                        // },
                        {
                            icon: "https://fugo-apps-prod.s3.amazonaws.com/app/vimeo/thumbnail.png",
                            name: "Vimeo App"
                        },
                    ]
                },
            ]
        }
    },
    computed: {
        getActiveCanvas() {
            return this.$store.getters.getCurrentActiveCanvas
        },
    },
    methods: {
        addWidget(type) {
            if (type === "Youtube App") {
                this.$store.dispatch("addObjectInCanvas",
                    {
                        id: `App_Youtube_${uuidv4()}`,
                        type: 'youtubeApp',
                        rotate: 0,
                        top: 0,
                        left: 0,
                        scaleX: 1,
                        scaleY: 1,
                        zoom: 1,
                        width: this.getActiveCanvas.size.width,
                        height: this.getActiveCanvas.size.height,
                        opacity: 1,
                        lock: false,
                        borderRadius: 0,
                        url: "https://www.youtube.com/embed/rokGy0huYEA",
                        isInAnimationActive: false,
                        isOutAnimationActive: false,
                        isLoopAnimationActive: false,
                        AnimationSequence: [],
                        animationClassIn: "",
                        animationClassOut: "",
                        animationClassLoop: "",
                        animationClass: "",
                        animationDelay: 0,
                        animationDuration: 2,
                        animationDelayIn: 0,
                        animationDurationIn: 2,
                        animationDelayOut: 0,
                        animationDurationOut: 2,
                        animationLoopDuration: 2,
                        animationLoop: false
                    },
                )
            } // In your methods: { addWidget(type) { ... } } block

            else if (type === "Countdown") {
                this.$store.dispatch("addObjectInCanvas", {
                    id: `App_Countdown_${uuidv4()}`,
                    type: 'countdownApp',
                    rotate: 0,
                    top: 0,
                    left: 0,
                    scaleX: 1,
                    scaleY: 1,
                    zoom: 1,
                    width: this.getActiveCanvas.size.width,
                    height: this.getActiveCanvas.size.height,
                    opacity: 1,
                    lock: false,
                    borderRadius: 0,
                    mainText: "New Event", 
                    targetDate: new Date(new Date().getFullYear() + 1, 0, 1, 0, 0, 0).toISOString(),
                    displayFormat: "DD:HH:MM:SS",
                    labelColor: "#FFFFFF", 
                    valueColor: "#FFFFFF", 
                    backgroundColor: "#2c4360", 
                    fontSize: 100,
                    fontFamily: "Arial",
                    showLabels: true, 
                    transparentBackground: false,
                    particleEffect: "Off",
                    isInAnimationActive: false,
                    isOutAnimationActive: false,
                    isLoopAnimationActive: false,
                    AnimationSequence: [],
                    animationClassIn: "",
                    animationClassOut: "",
                    animationClass: "",
                    animationClassLoop: "",
                    animationDelay: 0,
                    animationDuration: 2,
                    animationDelayIn: 0,
                    animationDurationIn: 2,
                    animationDelayOut: 0,
                    animationDurationOut: 2,
                    animationLoopDuration: 2,
                    animationLoop: false
                });
            } else if (type === "Vimeo App") {
                this.$store.dispatch("addObjectInCanvas",
                    {
                        id: `App_Vimeo_${uuidv4()}`,
                        type: 'vimeoApp',
                        rotate: 0,
                        top: 0,
                        left: 0,
                        scaleX: 1,
                        scaleY: 1,
                        zoom: 1,
                        width: this.getActiveCanvas.size.width,
                        height: this.getActiveCanvas.size.height,
                        opacity: 1,
                        lock: false,
                        borderRadius: 0,
                        url: "https://player.vimeo.com/video/355743316",
                        isInAnimationActive: false,
                        isOutAnimationActive: false,
                        isLoopAnimationActive: false,
                        AnimationSequence: [],
                        animationClassIn: "",
                        animationClassOut: "",
                        animationClass: "",
                        animationClassLoop: "",
                        animationDelay: 0,
                        animationDuration: 2,
                        animationDelayIn: 0,
                        animationDurationIn: 2,
                        animationDelayOut: 0,
                        animationDurationOut: 2,
                        animationLoopDuration: 2,
                        animationLoop: false
                    },
                )
            } else if (type === "World Clock") {
                this.$store.dispatch("addObjectInCanvas",
                    {
                        id: `App_Clock_${uuidv4()}`,
                        type: 'clockApp',
                        rotate: 0,
                        top: 0,
                        left: 0,
                        scaleX: 1,
                        scaleY: 1,
                        zoom: 1,
                        width: 750,
                        opacity: 1,
                        lock: false,
                        borderRadius: 0,
                        format: "24",
                        color: "black",
                        fs: 130,
                        timezone: "",
                        showSeconds: true,
                        isInAnimationActive: false,
                        isOutAnimationActive: false,
                        isLoopAnimationActive: false,
                        AnimationSequence: [],
                        animationClassIn: "",
                        animationClassOut: "",
                        animationClass: "",
                        animationClassLoop: "",
                        animationDelay: 0,
                        animationDuration: 2,
                        animationDelayIn: 0,
                        animationDurationIn: 2,
                        animationDelayOut: 0,
                        animationDurationOut: 2,
                        animationLoopDuration: 2,
                        animationLoop: false
                    },
                )
            } else if (type === "Calendar") {

                this.$store.dispatch("addObjectInCanvas",
                    {
                        id: `App_Calendar_${uuidv4()}`,
                        type: 'calendarApp',
                        rotate: 0,
                        top: 0,
                        left: 0,
                        scaleX: 1,
                        scaleY: 1,
                        zoom: 1,
                        width: 750,
                        bgColorL: "#00a6b6",
                        bgColorR: "#2c4360",
                        Hcolor: "#2c4360",
                        Dcolor: "#ffffff",
                        Tcolor: "#4eb15f",
                        height: this.getActiveCanvas.size.height,
                        lang: 'en',
                        beginweek: 'su',
                        opacity: 1,
                        lock: false,
                        borderRadius: 0,
                        format: "D.M.YYYY",
                        color: "black",
                        fs: 130,
                        cType: "half",
                        isInAnimationActive: false,
                        isOutAnimationActive: false,
                        isLoopAnimationActive: false,
                        AnimationSequence: [],
                        animationClassIn: "",
                        animationClassOut: "",
                        animationClass: "",
                        animationClassLoop: "",
                        animationDelay: 0,
                        animationDuration: 2,
                        animationDelayIn: 0,
                        animationDurationIn: 2,
                        animationDelayOut: 0,
                        animationDurationOut: 2,
                        animationLoopDuration: 2,
                        animationLoop: false
                    },
                )
            } else if (type === "Web Page") {
                this.$store.dispatch("addObjectInCanvas",
                    {
                        id: `App_WebPage_${uuidv4()}`,
                        type: 'webpageApp',
                        rotate: 0,
                        top: 0,
                        left: 0,
                        scaleX: 1,
                        scaleY: 1,
                        zoom: 1,
                        width: this.getActiveCanvas.size.width,
                        height: this.getActiveCanvas.size.height,
                        opacity: 1,
                        lock: false,
                        borderRadius: 0,
                        url: "https://en.wikipedia.org/wiki/Blockchain",
                        isScroll: true,
                        scrolltoPhrase: 0,
                        scrollSpeed: 50,
                        isInAnimationActive: false,
                        isOutAnimationActive: false,
                        isLoopAnimationActive: false,
                        AnimationSequence: [],
                        animationClassIn: "",
                        animationClassOut: "",
                        animationClassLoop: "",
                        animationClass: "",
                        animationDelay: 0,
                        animationDuration: 2,
                        animationDelayIn: 0,
                        animationDurationIn: 2,
                        animationDelayOut: 0,
                        animationDurationOut: 2,
                        animationLoopDuration: 2,
                        animationLoop: false
                    },
                )
            } else if (type === "QR Code") {
                this.$store.dispatch("addObjectInCanvas",
                    {
                        id: `App_qrCodeApp_${uuidv4()}`,
                        type: 'qrCodeApp',
                        rotate: 0,
                        top: 0,
                        left: 0,
                        scaleX: 1,
                        scaleY: 1,
                        zoom: 1,
                        width: this.getActiveCanvas.size.width,
                        height: this.getActiveCanvas.size.height,
                        opacity: 1,
                        lock: false,
                        borderRadius: 0,
                        url: "https://en.wikipedia.org/wiki/Blockchain",
                        transparentBG: true,
                        bgColor: "#ffffff",
                        lineColor: "#000000",
                        isInAnimationActive: false,
                        isOutAnimationActive: false,
                        isLoopAnimationActive: false,
                        AnimationSequence: [],
                        animationClassIn: "",
                        animationClassOut: "",
                        animationClassLoop: "",
                        animationClass: "",
                        animationDelay: 0,
                        animationDuration: 2,
                        animationDelayIn: 0,
                        animationDurationIn: 2,
                        animationDelayOut: 0,
                        animationDurationOut: 2,
                        animationLoopDuration: 2,
                        animationLoop: false
                    },
                )
            } else if (type === "World Weather") {
                this.$store.dispatch("addObjectInCanvas",
                    {
                        id: `App_Weather_${uuidv4()}`,
                        type: 'weatherApp',
                        rotate: 0,
                        top: 0,
                        left: 0,
                        scaleX: 1,
                        scaleY: 1,
                        zoom: 1,
                        width: 750,
                        opacity: 1,
                        lock: false,
                        borderRadius: 0,
                        layout: "sv1",
                        city: {},
                        unit: "C",
                        color: "#ffffff",
                        bgColor: "#104046",
                        fontfamily: "arial",
                        lang: "de",
                        fs: 90,
                        isAuto: true,
                        showForcast: true,
                        transparentbg: true,
                        isInAnimationActive: false,
                        isOutAnimationActive: false,
                        isLoopAnimationActive: false,
                        AnimationSequence: [],
                        animationClassIn: "",
                        animationClassOut: "",
                        animationClass: "",
                        animationClassLoop: "",
                        animationDelay: 0,
                        animationDuration: 2,
                        animationDelayIn: 0,
                        animationDurationIn: 2,
                        animationDelayOut: 0,
                        animationDurationOut: 2,
                        animationLoopDuration: 2,
                        animationLoop: false
                    },
                )
            }
            else if (type === "BBC News" || type === "Aljazeera News" || type === "Clarin News" || type === "CNN News" || type === "ESPN" || type === "Google News" || type === "Fox News" || type === "NTV News" || type === "WWD News" || type === "Yahoo News") {
                this.$store.dispatch("addObjectInCanvas",
                    {
                        id: `App_${newsType[type.split(" ")[0]]?.id}_News_${uuidv4()}`,
                        type: 'newsApp',
                        rotate: 0,
                        top: 0,
                        left: 0,
                        scaleX: 1,
                        scaleY: 1,
                        zoom: 1,
                        width: this.getActiveCanvas.size.width,
                        height: this.getActiveCanvas.size.height,
                        opacity: 1,
                        lock: false,
                        borderRadius: 0,
                        url: newsType[type.split(" ")[0]]?.url,
                        isInAnimationActive: false,
                        isOutAnimationActive: false,
                        isLoopAnimationActive: false,
                        AnimationSequence: [],
                        animationClassIn: "",
                        animationClassOut: "",
                        animationClass: "",
                        animationClassLoop: "",
                        animationDelay: 0,
                        animationDuration: 2,
                        animationDelayIn: 0,
                        animationDurationIn: 2,
                        animationDelayOut: 0,
                        animationDurationOut: 2,
                        animationLoopDuration: 2,
                        animationLoop: false,
                        headerColor: "#212529",
                        summaryColor: "#212529",
                        backgroundColor: "#ffffff",
                    },
                )
            }


        }

    }
}
</script>
<style scoped>
.addText {
    height: 45px;
    align-self: center;
    color: #495057;
}

.addText:hover {
    background-color: rgb(221 226 229);
}

.heading {
    font-weight: 900;
    font-size: 18px;
}

.subheading {
    font-weight: 500;
    font-size: 15px;
}

.bodytext {
    font-size: 13px;
}

.h-16 {
    height: 4rem;
}

.object-contain {
    object-fit: contain;
}

.text-xs {
    font-size: .75rem;
    line-height: 1rem;
}
</style>